import axiosInstance from "./axiosInstance";

export const groupChatService = {
  getGroups: async () => {
    const res = await axiosInstance.get("/GroupChat/groups");
    return res.data;
  },

  createGroup: async (groupName, members = []) => {
    const res = await axiosInstance.post("/GroupChat/groups", {
      groupName,
      members,
    });
    return res.data;
  },

  renameGroup: async (groupId, groupName) => {
    const res = await axiosInstance.put(`/GroupChat/groups/${groupId}`, { groupName });
    return res.data;
  },

  deleteGroup: async (groupId) => {
    const res = await axiosInstance.delete(`/GroupChat/groups/${groupId}`);
    return res.data;
  },

  getMembers: async (groupId) => {
    const res = await axiosInstance.get(`/GroupChat/groups/${groupId}/members`);
    return res.data;
  },

  addMembers: async (groupId, members = []) => {
    const res = await axiosInstance.post(`/GroupChat/groups/${groupId}/members`, { members });
    return res.data;
  },

  removeMember: async (groupId, { isStaff, studentId = null, staffId = null }) => {
    const params = new URLSearchParams();
    params.set("isStaff", String(!!isStaff));
    if (studentId) params.set("studentId", String(studentId));
    if (staffId) params.set("staffId", String(staffId));
    const res = await axiosInstance.delete(
      `/GroupChat/groups/${groupId}/members?${params.toString()}`
    );
    return res.data;
  },

  getHistory: async (groupId, pageNumber = 1, pageSize = 50) => {
    const res = await axiosInstance.get(
      `/GroupChat/groups/${groupId}/history?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return res.data;
  },

  sendMessage: async (groupId, message, imageUrl = null, audioUrl = null) => {
    const res = await axiosInstance.post(`/GroupChat/groups/${groupId}/send`, {
      message,
      imageUrl,
      audioUrl,
    });
    return res.data;
  },

  searchUsers: async (q, take = 20) => {
    const res = await axiosInstance.get(
      `/GroupChat/users/search?q=${encodeURIComponent(q)}&take=${take}`
    );
    return res.data;
  },

  uploadGroupImage: async (groupId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await axiosInstance.post(`/GroupChat/groups/${groupId}/upload-image`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },
};

export default groupChatService;
